<template src="@/templates/bookings/bookingStatusPopUp.html"></template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BookingStatusPopUp",
  props: ["bookingStatus", "ref_num"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["full_name"]),
  },
  created: function () {
    console.log("BookingStatusPopUp");
    console.log(this.bookingStatus);
  },
  methods: {
    closeBooking() {
      this.$emit("closeBookingPopUp", false);
    },
  },
};
</script>

<style scoped>
.bookingStatusAvailable {
  font-size: 24px;
  color: darkgreen;
}
</style>
